export const SET_MANAGING_INVITE = "SET_MANAGING_INVITE";
export const SET_INVITE_STATUS = "SET_INVITE_STATUS";
export const SET_USER = "SET_USER";
export const RESET_USER = "RESET_USER";
